module.exports = __webpack_public_path__ + "img/isOk.bb97c712.png";